import BaseApi from './base/BaseApi';

/**
 * Сообщение чата (ТЗ 4.1): тело { chat, text, files } — текст и/или вложения;
 * тип автора и подпись ставит сервер. Сгенерировано Claude.
 */
export default class SpecChatMessageApi extends BaseApi {
  static entityName = 'spec_chat_messages';
}
